import { IContentState, setContent } from "./contentSlice";
import { put, take, takeEvery } from "redux-saga/effects";
import { buffers, END, eventChannel } from "redux-saga";
import { onValue, ref } from "firebase/database";
import { database } from "../../firebase/firebase";

function* syncContent() {
  const channel = eventChannel<IContentState>((emitter) => {
    return onValue(
      ref(database, "data"),
      (snapshot) => {
        const data = snapshot.val();
        if (data) emitter(data);
      },
      (error) => {
        console.error("content sync failed", error);
        emitter(END);
      }
    );
  }, buffers.expanding(1));
  while (true) {
    const data: IContentState = yield take(channel);
    yield put(setContent(data));
  }
}

function* contentSaga() {
  yield takeEvery("content/getContent", syncContent);
}

export default contentSaga;
